import { apiClient } from "./ApiClient";

export const retrieveBirthdayPersonsApi = () =>
  apiClient.get(`/api/birthday-persons`);

export const createBirthdayPersonApi = (payload) =>
  apiClient.post(`/api/birthday-persons`, payload);

export const deleteBirthdayPersonApi = (id) =>
  apiClient.delete(`/api/birthday-persons/${id}`);

export const updateBirthdayPersonApi = (id, payload) =>
  apiClient.put(`/api/birthday-persons/${id}`, payload);